<template>
  <router-link
    :to="item.path"
    style="text-decoration: none; color: inherit"
    v-if="!item.disabled"
  >
    <v-list-item v-ripple="{ class: 'primary--text' }">
      <v-list-item-icon>
        <v-icon>
          {{ item.icon }}
        </v-icon>
      </v-list-item-icon>

      <v-list-item-content>
        <v-list-item-title>
          {{ item.title }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </router-link>
  <v-list-item v-else color="primary">
    <v-list-item-icon>
      <v-icon class="grey--text"> {{ item.icon }}</v-icon>
    </v-list-item-icon>

    <v-list-item-content>
      <v-list-item-title class="grey--text">
        {{ item.title }}
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  props: {
    item: {},
  },
};
</script>